import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../../core/pagination/datatable";

import PropTypes from "prop-types";

import { Select, Spin, Tag } from "antd";
import dayjs from "dayjs";
import { BASE_CRM_URL } from "../../../../components/config/config";

import Swal from "sweetalert2";
import CommonFooter from "../../../../../core/common/footer/commonFooter";

const ProjectProposal = ({ projectId }) => {
  const truncateString = (inputString) => {
    if (inputString.length > 35) {
      return inputString.slice(0, 35) + "...";
    }
    return inputString;
  };

  const proposalStatusColors = {
    Sent: "green",
    Pending: "orange",
    Declined: "red",
    Draft: "blue",
    Accepted: "success",
    Default: "default",
  };

  const [proposalStatusOptions, setProposalStatusOptions] = useState([]);
  //   const [selectedStatus, setSelectedStatus] = useState(0);
  const [proposalList, setProposalList] = useState([]);
  const [loading, setLoading] = useState(false);

  const getProposalStatuses = async () => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}proposal/GetProposalsStatus`,
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.ProposalStatus,
        }));

        setProposalStatusOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  console.log(proposalStatusOptions, "proposalStatusOptions");

  const columns = [
    {
      title: "#",
      dataIndex: "number",

      render: (text, record) => (
        <Link
          to={`/crm/view/proposal`}
          state={{ record }}
          className="text-decoration-none"
        >
          <Tag
            color={
              proposalStatusColors[record.StatusName] ||
              proposalStatusColors.Default
            }
            bordered={false}
            style={{
              borderRadius: 20,
              padding: "4px 12px",
              fontWeight: 600,
              fontSize: 13,
            }}
          >
            {text}
          </Tag>
        </Link>
      ),
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",

      render: (text, record) => (
        <div className="d-flex align-items-start">
          <div title={text}>
            <Link
              to={`/crm/view/proposal`}
              state={{ record }}
              className="fw-semibold text-dark text-decoration-none"
            >
              {truncateString(text)}
            </Link>
          </div>
        </div>
      ),
    },

    {
      title: "Proposal",
      dataIndex: "proposal_to",

      render: (_, record) => {
        return (
          <div className="d-flex align-items-start">
            <div className="ms-3" title={record.proposal_to}>
              <i className="fa-regular fa-user text-info me-2"></i>
              {record.proposal_to?.length > 20
                ? `${record.proposal_to.substring(0, 20)}...`
                : record.proposal_to}
            </div>
          </div>
        );
      },
    },

    {
      title: "Amount",
      dataIndex: "total",

      render: (amount) => (
        <>
          <div className="fw-semibold">
            <i className="fa-solid fa-indian-rupee-sign text-success me-2"></i>
            {amount}
          </div>
        </>
      ),
    },

    {
      title: "Timeline",

      render: (_, record) => (
        <>
          <div>
            {/* <i className="fa-regular fa-calendar me-2 text-primary"></i> */}
            {dayjs(record.datecreated).format("DD-MM-YYYY") || "-"}
          </div>

          <small className="text-muted text-danger">
            {/* <i className="fa-regular fa-clock me-2"></i> */}
            {dayjs(record.open_till).format("DD-MM-YYYY") || "-"}
          </small>
        </>
      ),
    },

    {
      title: "Project",
      dataIndex: "projectName",

      render: (_, record) => (
        <span title={record.projectName}>
          {record.projectName
            ? record.projectName.length > 10
              ? `${record.projectName.substring(0, 10)}...`
              : record.projectName
            : "N/A"}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "StatusName",

      render: (text, record) => {
        const getColor = (status) => {
          switch (status) {
            case "Draft":
              return "#6c757d";
            case "Sent":
              return "#0d6efd";
            case "Open":
              return "#0dcaf0";
            case "Revised":
              return "#ffc107";
            case "Declined":
              return "#dc3545";
            case "Accepted":
              return "#198754";
            default:
              return "#6c757d";
          }
        };

        return (
          <Select
            value={
              proposalStatusOptions.find(
                (item) => item.label === (text || "Draft"),
              )?.value
            }
            style={{ width: 100 }}
            options={proposalStatusOptions}
            onChange={(value) => {
              updateProposalStatus(record.id, value);
            }}
            dropdownStyle={{ zIndex: 9999 }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: 10,
                  }}
                ></i>

                {option.data.label}
              </div>
            )}
            labelRender={({ value }) => {
              const status = proposalStatusOptions.find(
                (x) => x.value === value,
              );

              return (
                <span>
                  <i
                    className="fa-solid fa-circle me-2"
                    style={{
                      color: getColor(status?.label),
                      fontSize: 10,
                    }}
                  ></i>
                  {status?.label}
                </span>
              );
            }}
          />
        );
      },
    },

    {
      title: "Action",

      render: (_, record) => (
        <>
          {/* <Link className="action-set" to="#" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v btn border"></i>
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                className="dropdown-item"
                to={`/crm/view/proposal`}
                state={{ record }}
              >
                <Eye className="me-2 text-info" />
                View
              </Link>
            </li>

            <li>
              <Link
                to={`/crm/update/proposal/${record.id}`}
                className="dropdown-item"
                state={{
                  proposalId: record.id,
                  record,
                }}
              >
                <Edit className="text-secondary me-2" />
                Edit
              </Link>
            </li>
          </ul> */}

          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                to={`/crm/update/proposal/${record.id}`}
                className="me-2 p-2 shadow-sm"
                state={{
                  proposalId: record.id,
                  record,
                }}
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];

  const getProposals = async (status = 0) => {
    try {
      setLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}proposal/GetProposalsByProjId?status=${status}&ProjectId=${projectId}`,
      );

      const data = await response.json();

      if (data.Status) {
        setProposalList(data.ResultData);
      } else {
        setProposalList([]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProposals(0);
    getProposalStatuses();
  }, []);

  const updateProposalStatus = async (proposalId, statusId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}proposal/UpdateProposalStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: proposalId,
            status: statusId,
          }),
        },
      );

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1200,
          showConfirmButton: false,
        });

        getProposals(0);
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="page-wrapper py-0">
      <div className="content py-0">
        <div className="page-header py-0">
          <div className="add-item">
            <div className="d-flex flex-column">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <h4 className="breadcrumb-item " aria-current="page">
                    Project Proposal
                  </h4>
                </ol>
              </nav>
            </div>
          </div>
        </div>

        {/* /product list */}
        <div className="card table-list-card ">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set p-3"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              {/* <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Status
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Sent
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Declined
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Pending
                      </Link>
                    </li>
                  </ul>
                </div> */}
            </div>
          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={proposalList} />
              )}
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>
      <CommonFooter />
    </div>
  );
};
ProjectProposal.propTypes = {
  projectId: PropTypes.number,
};

export default ProjectProposal;
